export const msalConfig = {
    auth: {
      clientId: "d721891e-6aed-4e49-8780-241c4169838c",
      authority: "https://login.microsoftonline.com/92e84ceb-fbfd-47ab-be52-080c6b87953f",
      redirectUri: "/", 
      postLogoutRedirectUrl: '/',
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: "localStorage", 
      storeAuthStateInCookie: true,
    },
  };
  
  export const loginRequest = {
    scopes: ["User.Read"],
  };
  
